import { listenDialogsControls } from '@frontend/shared/src/utils/dialog';
import { PersistentWallOfShameAPIKey } from '../../helpers/PersistentWallOfShameAPIKey';

import './wall-of-shame-dialog-settings.css';

const ATTR = 'wall-of-shame-dialog-settings';

export class WallOfShameDialogSettings extends HTMLDialogElement {
  constructor() {
    super();

    this.setAttribute('is', ATTR);
  }

  connectedCallback() {
    listenDialogsControls('settings');

    const input = this.querySelector<HTMLInputElement>('.api-key input')!;

    input.value = PersistentWallOfShameAPIKey.get() ?? '';

    input.addEventListener('input', ({ currentTarget }) => {
      const value = (currentTarget as HTMLInputElement).value;

      PersistentWallOfShameAPIKey.set(value);

      document.body.dataset.moderated = String(value.length > 0);
    });

    input.dispatchEvent(new Event('input'));
  }
}

customElements.whenDefined(ATTR).then(() => console.log('[DEFINED]', ATTR));
customElements.define(ATTR, WallOfShameDialogSettings, { extends: 'dialog' });
